import {sendings} from './sendings'

export { sendings }

export default {
    sendings
}